// A creative's age rating can never be more permissive than its company's.
// An adult-only company (only_for_adults) has the "Anuncio para adultos"
// switch hidden, so the flag must be derived, not left at a component
// default: the Hall form used to start at `false`, which stored 18+ companies'
// Atrio creatives as all-ages and let them be served to minors.

export function initialCreativeAdultFlag(
  storedIsAdult: boolean | undefined,
  orgIsOnlyForAdults: boolean,
): boolean {
  if (orgIsOnlyForAdults) return true;
  return storedIsAdult ?? false;
}

export function creativeAdultFlag(isAdult: boolean, orgIsOnlyForAdults: boolean): boolean {
  return orgIsOnlyForAdults || isAdult;
}
